import { Actions } from './driverActions';
import { DriversConstants } from './driversConstants';
import { IDriverState } from './driversState';

export const initialState: IDriverState = {
  driverList: [],
  isLoading: false,
  errorMessage: null,
};

export function drivers(
  state: IDriverState = initialState,
  action: Actions,
): IDriverState {
  switch (action.type) {
    case DriversConstants.GET_CONTRACTOR_DRIVERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DriversConstants.GET_CONTRACTOR_DRIVERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        driverList: action.payload,
      };
    case DriversConstants.GET_CONTRACTOR_DRIVERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error.message,
      };
    default:
      return state;
  }
}
